module.exports = __webpack_public_path__ + "img/dropping keystones.c770bdab.png";